/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Downloads {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { Downloads as DownloadsModule } from "@bw/modules"

const Downloads = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  files,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        files,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
    >
      <DownloadsModule
        files={files.map(file => ({ ...file, fileUrl: file.file?.url }))}
      />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on DownloadsModule {
 *   ...DownloadsModuleFragment
 * }
 *
 * This is also what you will get in the props of your Downloads
 * resolver component.
 */
export const query = graphql`
  fragment DownloadsModuleFragment on DownloadsModule {
    files {
      title
      description
      file {
        url
      }
    }
  }
`

export { Downloads }
